import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import VturbPlayer from "@/components/site/VturbPlayer";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

// Standard Divorce page copy — kept identical to /orange-county-divorce-attorney
// so v2 can be A/B tested cleanly against v1 (video-forward) with the only
// difference being the position of the VSL video.
const headline = (
  <>
    Your marriage may be ending.{" "}
    <span className="italic text-teal">Your life is not.</span>
  </>
);
const subhead = (
  <>
    Mr. Binoye Jos, Esq. built this firm after hiring{" "}
    <span className="text-ink font-medium">two prominent law firms</span>,
    spending <span className="text-ink font-medium">$400,000</span>, and being
    told he&rsquo;d never get equal custody of his son. He fired them,
    represented himself, won equal custody, then went to law school. He knows
    what&rsquo;s at stake when your finances, your home, and your
    children&rsquo;s future are all on the table at once.
  </>
);
const pullquote = (
  <>
    Your marriage may be ending. Your life is not.{" "}
    <span className="italic text-teal">
      We will protect what you&rsquo;ve built — and guide you toward a brighter
      future.
    </span>
  </>
);

export default function DivorceVSLSplit() {
  return (
    <main data-testid="divorce-vsl-split-page" className="relative bg-paper text-ink">
      <NavBar />
      <Hero
        headline={headline}
        subhead={subhead}
        pullquote={pullquote}
        pullquoteLabel="Our Promise"
        source="Divorce VSL v2"
        compact
      />
      <VturbPlayer videoId="6a59cf57d8f4fab17740c91c" />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="Divorce VSL v2" />
      <Footer />
    </main>
  );
}
